"use strict";

import React from 'react';
import passwordValidationSettings from "../../account/utilities/passwordValidationSettings";
import PasswordError from "../../account/component/PasswordError";

const RegisterCredentialsFormInput = ({data={},errors={},register=()=>{},trigger=()=>{},getValues=()=>{},formInputClassName=()=>{},}) => {

    return (
        <fieldset className="echeck___form__fieldset">
            <ol className="form__input-list echeck___form__list">
                <li className="form__input-list-item">
                    <label htmlFor="account-form---password">Password:</label>
                    <input type="password"
                           {...register('password', passwordValidationSettings)}
                           autoFocus={true}
                           id="account-form--password"
                           defaultValue=""
                           className={formInputClassName('password')} />
                    <PasswordError error={errors.password} />
                </li>
                <li className="form__input-list-item">
                    <label htmlFor="account-form--password_confirm">Confirm Password:</label>
                    <input type="password"
                           {...register('password_confirm', {...passwordValidationSettings,
                               validate: {
                                   matchesPreviousPassword: (value) => {
                                       const {password} = getValues();
                                       return password === value || 'Passwords should match!';
                                   },
                               },
                           })}
                           id="account-form---password_confirm"
                           autoComplete="off"
                           defaultValue=""
                           className={formInputClassName('password_confirm')}/>
                    {!!errors.password_confirm &&
                        <small className="form__error">
                            Passwords do not match
                        </small>
                    }
                </li>
            </ol>
        </fieldset>
    );
};

export default RegisterCredentialsFormInput;
